// source: pbtypes/vehicle/crosshair_util/crosshair.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.crosshair_util.CrosshairCoordinates', null, global);
goog.exportSymbol('proto.crosshair_util.CrosshairCoordinates.DataSource', null, global);
goog.exportSymbol('proto.crosshair_util.CrosshairStatus', null, global);
goog.exportSymbol('proto.crosshair_util.CrosshairStatus.Enum', null, global);
goog.exportSymbol('proto.crosshair_util.FrameCoordinates', null, global);
goog.exportSymbol('proto.crosshair_util.MinimalCrosshairAndFrameCoordinates', null, global);
goog.exportSymbol('proto.crosshair_util.PositionCoordinatesInt', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.crosshair_util.CrosshairStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.crosshair_util.CrosshairStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.crosshair_util.CrosshairStatus.displayName = 'proto.crosshair_util.CrosshairStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.crosshair_util.CrosshairCoordinates = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.crosshair_util.CrosshairCoordinates, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.crosshair_util.CrosshairCoordinates.displayName = 'proto.crosshair_util.CrosshairCoordinates';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.crosshair_util.FrameCoordinates = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.crosshair_util.FrameCoordinates, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.crosshair_util.FrameCoordinates.displayName = 'proto.crosshair_util.FrameCoordinates';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.crosshair_util.PositionCoordinatesInt = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.crosshair_util.PositionCoordinatesInt, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.crosshair_util.PositionCoordinatesInt.displayName = 'proto.crosshair_util.PositionCoordinatesInt';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.crosshair_util.MinimalCrosshairAndFrameCoordinates, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.displayName = 'proto.crosshair_util.MinimalCrosshairAndFrameCoordinates';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.crosshair_util.CrosshairStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.crosshair_util.CrosshairStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.crosshair_util.CrosshairStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.crosshair_util.CrosshairStatus.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.crosshair_util.CrosshairStatus}
 */
proto.crosshair_util.CrosshairStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.crosshair_util.CrosshairStatus;
  return proto.crosshair_util.CrosshairStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.crosshair_util.CrosshairStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.crosshair_util.CrosshairStatus}
 */
proto.crosshair_util.CrosshairStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.crosshair_util.CrosshairStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.crosshair_util.CrosshairStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.crosshair_util.CrosshairStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.crosshair_util.CrosshairStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.crosshair_util.CrosshairStatus.Enum = {
  UNKNOWN: 0,
  DATA_IS_VALID: 1,
  DATA_IS_INVALID: 2,
  DISABLED: 3,
  COMPUTING: 4
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.crosshair_util.CrosshairCoordinates.prototype.toObject = function(opt_includeInstance) {
  return proto.crosshair_util.CrosshairCoordinates.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.crosshair_util.CrosshairCoordinates} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.crosshair_util.CrosshairCoordinates.toObject = function(includeInstance, msg) {
  var f, obj = {
status: jspb.Message.getFieldWithDefault(msg, 1, 0),
latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
terrainHeight: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
distance: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
utime: jspb.Message.getFieldWithDefault(msg, 6, 0),
source: jspb.Message.getFieldWithDefault(msg, 7, 0),
error: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.crosshair_util.CrosshairCoordinates}
 */
proto.crosshair_util.CrosshairCoordinates.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.crosshair_util.CrosshairCoordinates;
  return proto.crosshair_util.CrosshairCoordinates.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.crosshair_util.CrosshairCoordinates} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.crosshair_util.CrosshairCoordinates}
 */
proto.crosshair_util.CrosshairCoordinates.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.crosshair_util.CrosshairStatus.Enum} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTerrainHeight(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDistance(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 7:
      var value = /** @type {!proto.crosshair_util.CrosshairCoordinates.DataSource} */ (reader.readEnum());
      msg.setSource(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.crosshair_util.CrosshairCoordinates.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.crosshair_util.CrosshairCoordinates.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.crosshair_util.CrosshairCoordinates} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.crosshair_util.CrosshairCoordinates.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getTerrainHeight();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getDistance();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.crosshair_util.CrosshairCoordinates.DataSource = {
  DTED: 0,
  RANGEFINDING: 1
};

/**
 * optional CrosshairStatus.Enum status = 1;
 * @return {!proto.crosshair_util.CrosshairStatus.Enum}
 */
proto.crosshair_util.CrosshairCoordinates.prototype.getStatus = function() {
  return /** @type {!proto.crosshair_util.CrosshairStatus.Enum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.crosshair_util.CrosshairStatus.Enum} value
 * @return {!proto.crosshair_util.CrosshairCoordinates} returns this
 */
proto.crosshair_util.CrosshairCoordinates.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional double latitude = 2;
 * @return {number}
 */
proto.crosshair_util.CrosshairCoordinates.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.crosshair_util.CrosshairCoordinates} returns this
 */
proto.crosshair_util.CrosshairCoordinates.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double longitude = 3;
 * @return {number}
 */
proto.crosshair_util.CrosshairCoordinates.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.crosshair_util.CrosshairCoordinates} returns this
 */
proto.crosshair_util.CrosshairCoordinates.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double terrain_height = 4;
 * @return {number}
 */
proto.crosshair_util.CrosshairCoordinates.prototype.getTerrainHeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.crosshair_util.CrosshairCoordinates} returns this
 */
proto.crosshair_util.CrosshairCoordinates.prototype.setTerrainHeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double distance = 5;
 * @return {number}
 */
proto.crosshair_util.CrosshairCoordinates.prototype.getDistance = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.crosshair_util.CrosshairCoordinates} returns this
 */
proto.crosshair_util.CrosshairCoordinates.prototype.setDistance = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional int64 utime = 6;
 * @return {number}
 */
proto.crosshair_util.CrosshairCoordinates.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.crosshair_util.CrosshairCoordinates} returns this
 */
proto.crosshair_util.CrosshairCoordinates.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional DataSource source = 7;
 * @return {!proto.crosshair_util.CrosshairCoordinates.DataSource}
 */
proto.crosshair_util.CrosshairCoordinates.prototype.getSource = function() {
  return /** @type {!proto.crosshair_util.CrosshairCoordinates.DataSource} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.crosshair_util.CrosshairCoordinates.DataSource} value
 * @return {!proto.crosshair_util.CrosshairCoordinates} returns this
 */
proto.crosshair_util.CrosshairCoordinates.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional string error = 8;
 * @return {string}
 */
proto.crosshair_util.CrosshairCoordinates.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.crosshair_util.CrosshairCoordinates} returns this
 */
proto.crosshair_util.CrosshairCoordinates.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.crosshair_util.FrameCoordinates.prototype.toObject = function(opt_includeInstance) {
  return proto.crosshair_util.FrameCoordinates.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.crosshair_util.FrameCoordinates} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.crosshair_util.FrameCoordinates.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
topLeft: (f = msg.getTopLeft()) && proto.crosshair_util.CrosshairCoordinates.toObject(includeInstance, f),
topRight: (f = msg.getTopRight()) && proto.crosshair_util.CrosshairCoordinates.toObject(includeInstance, f),
bottomLeft: (f = msg.getBottomLeft()) && proto.crosshair_util.CrosshairCoordinates.toObject(includeInstance, f),
bottomRight: (f = msg.getBottomRight()) && proto.crosshair_util.CrosshairCoordinates.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.crosshair_util.FrameCoordinates}
 */
proto.crosshair_util.FrameCoordinates.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.crosshair_util.FrameCoordinates;
  return proto.crosshair_util.FrameCoordinates.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.crosshair_util.FrameCoordinates} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.crosshair_util.FrameCoordinates}
 */
proto.crosshair_util.FrameCoordinates.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 2:
      var value = new proto.crosshair_util.CrosshairCoordinates;
      reader.readMessage(value,proto.crosshair_util.CrosshairCoordinates.deserializeBinaryFromReader);
      msg.setTopLeft(value);
      break;
    case 3:
      var value = new proto.crosshair_util.CrosshairCoordinates;
      reader.readMessage(value,proto.crosshair_util.CrosshairCoordinates.deserializeBinaryFromReader);
      msg.setTopRight(value);
      break;
    case 4:
      var value = new proto.crosshair_util.CrosshairCoordinates;
      reader.readMessage(value,proto.crosshair_util.CrosshairCoordinates.deserializeBinaryFromReader);
      msg.setBottomLeft(value);
      break;
    case 5:
      var value = new proto.crosshair_util.CrosshairCoordinates;
      reader.readMessage(value,proto.crosshair_util.CrosshairCoordinates.deserializeBinaryFromReader);
      msg.setBottomRight(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.crosshair_util.FrameCoordinates.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.crosshair_util.FrameCoordinates.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.crosshair_util.FrameCoordinates} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.crosshair_util.FrameCoordinates.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTopLeft();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.crosshair_util.CrosshairCoordinates.serializeBinaryToWriter
    );
  }
  f = message.getTopRight();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.crosshair_util.CrosshairCoordinates.serializeBinaryToWriter
    );
  }
  f = message.getBottomLeft();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.crosshair_util.CrosshairCoordinates.serializeBinaryToWriter
    );
  }
  f = message.getBottomRight();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.crosshair_util.CrosshairCoordinates.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 utime = 1;
 * @return {number}
 */
proto.crosshair_util.FrameCoordinates.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.crosshair_util.FrameCoordinates} returns this
 */
proto.crosshair_util.FrameCoordinates.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional CrosshairCoordinates top_left = 2;
 * @return {?proto.crosshair_util.CrosshairCoordinates}
 */
proto.crosshair_util.FrameCoordinates.prototype.getTopLeft = function() {
  return /** @type{?proto.crosshair_util.CrosshairCoordinates} */ (
    jspb.Message.getWrapperField(this, proto.crosshair_util.CrosshairCoordinates, 2));
};


/**
 * @param {?proto.crosshair_util.CrosshairCoordinates|undefined} value
 * @return {!proto.crosshair_util.FrameCoordinates} returns this
*/
proto.crosshair_util.FrameCoordinates.prototype.setTopLeft = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.crosshair_util.FrameCoordinates} returns this
 */
proto.crosshair_util.FrameCoordinates.prototype.clearTopLeft = function() {
  return this.setTopLeft(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.crosshair_util.FrameCoordinates.prototype.hasTopLeft = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional CrosshairCoordinates top_right = 3;
 * @return {?proto.crosshair_util.CrosshairCoordinates}
 */
proto.crosshair_util.FrameCoordinates.prototype.getTopRight = function() {
  return /** @type{?proto.crosshair_util.CrosshairCoordinates} */ (
    jspb.Message.getWrapperField(this, proto.crosshair_util.CrosshairCoordinates, 3));
};


/**
 * @param {?proto.crosshair_util.CrosshairCoordinates|undefined} value
 * @return {!proto.crosshair_util.FrameCoordinates} returns this
*/
proto.crosshair_util.FrameCoordinates.prototype.setTopRight = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.crosshair_util.FrameCoordinates} returns this
 */
proto.crosshair_util.FrameCoordinates.prototype.clearTopRight = function() {
  return this.setTopRight(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.crosshair_util.FrameCoordinates.prototype.hasTopRight = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional CrosshairCoordinates bottom_left = 4;
 * @return {?proto.crosshair_util.CrosshairCoordinates}
 */
proto.crosshair_util.FrameCoordinates.prototype.getBottomLeft = function() {
  return /** @type{?proto.crosshair_util.CrosshairCoordinates} */ (
    jspb.Message.getWrapperField(this, proto.crosshair_util.CrosshairCoordinates, 4));
};


/**
 * @param {?proto.crosshair_util.CrosshairCoordinates|undefined} value
 * @return {!proto.crosshair_util.FrameCoordinates} returns this
*/
proto.crosshair_util.FrameCoordinates.prototype.setBottomLeft = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.crosshair_util.FrameCoordinates} returns this
 */
proto.crosshair_util.FrameCoordinates.prototype.clearBottomLeft = function() {
  return this.setBottomLeft(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.crosshair_util.FrameCoordinates.prototype.hasBottomLeft = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional CrosshairCoordinates bottom_right = 5;
 * @return {?proto.crosshair_util.CrosshairCoordinates}
 */
proto.crosshair_util.FrameCoordinates.prototype.getBottomRight = function() {
  return /** @type{?proto.crosshair_util.CrosshairCoordinates} */ (
    jspb.Message.getWrapperField(this, proto.crosshair_util.CrosshairCoordinates, 5));
};


/**
 * @param {?proto.crosshair_util.CrosshairCoordinates|undefined} value
 * @return {!proto.crosshair_util.FrameCoordinates} returns this
*/
proto.crosshair_util.FrameCoordinates.prototype.setBottomRight = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.crosshair_util.FrameCoordinates} returns this
 */
proto.crosshair_util.FrameCoordinates.prototype.clearBottomRight = function() {
  return this.setBottomRight(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.crosshair_util.FrameCoordinates.prototype.hasBottomRight = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.crosshair_util.PositionCoordinatesInt.prototype.toObject = function(opt_includeInstance) {
  return proto.crosshair_util.PositionCoordinatesInt.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.crosshair_util.PositionCoordinatesInt} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.crosshair_util.PositionCoordinatesInt.toObject = function(includeInstance, msg) {
  var f, obj = {
latitudeE7: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
longitudeE7: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
heightMm: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.crosshair_util.PositionCoordinatesInt}
 */
proto.crosshair_util.PositionCoordinatesInt.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.crosshair_util.PositionCoordinatesInt;
  return proto.crosshair_util.PositionCoordinatesInt.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.crosshair_util.PositionCoordinatesInt} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.crosshair_util.PositionCoordinatesInt}
 */
proto.crosshair_util.PositionCoordinatesInt.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setLatitudeE7(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setLongitudeE7(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setHeightMm(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.crosshair_util.PositionCoordinatesInt.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.crosshair_util.PositionCoordinatesInt.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.crosshair_util.PositionCoordinatesInt} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.crosshair_util.PositionCoordinatesInt.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeSfixed32(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeSfixed32(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeSint32(
      3,
      f
    );
  }
};


/**
 * optional sfixed32 latitude_e7 = 1;
 * @return {number}
 */
proto.crosshair_util.PositionCoordinatesInt.prototype.getLatitudeE7 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.crosshair_util.PositionCoordinatesInt} returns this
 */
proto.crosshair_util.PositionCoordinatesInt.prototype.setLatitudeE7 = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.crosshair_util.PositionCoordinatesInt} returns this
 */
proto.crosshair_util.PositionCoordinatesInt.prototype.clearLatitudeE7 = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.crosshair_util.PositionCoordinatesInt.prototype.hasLatitudeE7 = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional sfixed32 longitude_e7 = 2;
 * @return {number}
 */
proto.crosshair_util.PositionCoordinatesInt.prototype.getLongitudeE7 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.crosshair_util.PositionCoordinatesInt} returns this
 */
proto.crosshair_util.PositionCoordinatesInt.prototype.setLongitudeE7 = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.crosshair_util.PositionCoordinatesInt} returns this
 */
proto.crosshair_util.PositionCoordinatesInt.prototype.clearLongitudeE7 = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.crosshair_util.PositionCoordinatesInt.prototype.hasLongitudeE7 = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional sint32 height_mm = 3;
 * @return {number}
 */
proto.crosshair_util.PositionCoordinatesInt.prototype.getHeightMm = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.crosshair_util.PositionCoordinatesInt} returns this
 */
proto.crosshair_util.PositionCoordinatesInt.prototype.setHeightMm = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.crosshair_util.PositionCoordinatesInt} returns this
 */
proto.crosshair_util.PositionCoordinatesInt.prototype.clearHeightMm = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.crosshair_util.PositionCoordinatesInt.prototype.hasHeightMm = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.prototype.toObject = function(opt_includeInstance) {
  return proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.crosshair_util.MinimalCrosshairAndFrameCoordinates} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
status: jspb.Message.getFieldWithDefault(msg, 2, 0),
crosshair: (f = msg.getCrosshair()) && proto.crosshair_util.PositionCoordinatesInt.toObject(includeInstance, f),
topLeft: (f = msg.getTopLeft()) && proto.crosshair_util.PositionCoordinatesInt.toObject(includeInstance, f),
topRight: (f = msg.getTopRight()) && proto.crosshair_util.PositionCoordinatesInt.toObject(includeInstance, f),
bottomLeft: (f = msg.getBottomLeft()) && proto.crosshair_util.PositionCoordinatesInt.toObject(includeInstance, f),
bottomRight: (f = msg.getBottomRight()) && proto.crosshair_util.PositionCoordinatesInt.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.crosshair_util.MinimalCrosshairAndFrameCoordinates}
 */
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.crosshair_util.MinimalCrosshairAndFrameCoordinates;
  return proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.crosshair_util.MinimalCrosshairAndFrameCoordinates} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.crosshair_util.MinimalCrosshairAndFrameCoordinates}
 */
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 2:
      var value = /** @type {!proto.crosshair_util.CrosshairStatus.Enum} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = new proto.crosshair_util.PositionCoordinatesInt;
      reader.readMessage(value,proto.crosshair_util.PositionCoordinatesInt.deserializeBinaryFromReader);
      msg.setCrosshair(value);
      break;
    case 4:
      var value = new proto.crosshair_util.PositionCoordinatesInt;
      reader.readMessage(value,proto.crosshair_util.PositionCoordinatesInt.deserializeBinaryFromReader);
      msg.setTopLeft(value);
      break;
    case 5:
      var value = new proto.crosshair_util.PositionCoordinatesInt;
      reader.readMessage(value,proto.crosshair_util.PositionCoordinatesInt.deserializeBinaryFromReader);
      msg.setTopRight(value);
      break;
    case 6:
      var value = new proto.crosshair_util.PositionCoordinatesInt;
      reader.readMessage(value,proto.crosshair_util.PositionCoordinatesInt.deserializeBinaryFromReader);
      msg.setBottomLeft(value);
      break;
    case 7:
      var value = new proto.crosshair_util.PositionCoordinatesInt;
      reader.readMessage(value,proto.crosshair_util.PositionCoordinatesInt.deserializeBinaryFromReader);
      msg.setBottomRight(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.crosshair_util.MinimalCrosshairAndFrameCoordinates} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getCrosshair();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.crosshair_util.PositionCoordinatesInt.serializeBinaryToWriter
    );
  }
  f = message.getTopLeft();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.crosshair_util.PositionCoordinatesInt.serializeBinaryToWriter
    );
  }
  f = message.getTopRight();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.crosshair_util.PositionCoordinatesInt.serializeBinaryToWriter
    );
  }
  f = message.getBottomLeft();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.crosshair_util.PositionCoordinatesInt.serializeBinaryToWriter
    );
  }
  f = message.getBottomRight();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.crosshair_util.PositionCoordinatesInt.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 utime = 1;
 * @return {number}
 */
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.crosshair_util.MinimalCrosshairAndFrameCoordinates} returns this
 */
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional CrosshairStatus.Enum status = 2;
 * @return {!proto.crosshair_util.CrosshairStatus.Enum}
 */
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.prototype.getStatus = function() {
  return /** @type {!proto.crosshair_util.CrosshairStatus.Enum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.crosshair_util.CrosshairStatus.Enum} value
 * @return {!proto.crosshair_util.MinimalCrosshairAndFrameCoordinates} returns this
 */
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional PositionCoordinatesInt crosshair = 3;
 * @return {?proto.crosshair_util.PositionCoordinatesInt}
 */
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.prototype.getCrosshair = function() {
  return /** @type{?proto.crosshair_util.PositionCoordinatesInt} */ (
    jspb.Message.getWrapperField(this, proto.crosshair_util.PositionCoordinatesInt, 3));
};


/**
 * @param {?proto.crosshair_util.PositionCoordinatesInt|undefined} value
 * @return {!proto.crosshair_util.MinimalCrosshairAndFrameCoordinates} returns this
*/
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.prototype.setCrosshair = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.crosshair_util.MinimalCrosshairAndFrameCoordinates} returns this
 */
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.prototype.clearCrosshair = function() {
  return this.setCrosshair(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.prototype.hasCrosshair = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional PositionCoordinatesInt top_left = 4;
 * @return {?proto.crosshair_util.PositionCoordinatesInt}
 */
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.prototype.getTopLeft = function() {
  return /** @type{?proto.crosshair_util.PositionCoordinatesInt} */ (
    jspb.Message.getWrapperField(this, proto.crosshair_util.PositionCoordinatesInt, 4));
};


/**
 * @param {?proto.crosshair_util.PositionCoordinatesInt|undefined} value
 * @return {!proto.crosshair_util.MinimalCrosshairAndFrameCoordinates} returns this
*/
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.prototype.setTopLeft = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.crosshair_util.MinimalCrosshairAndFrameCoordinates} returns this
 */
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.prototype.clearTopLeft = function() {
  return this.setTopLeft(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.prototype.hasTopLeft = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional PositionCoordinatesInt top_right = 5;
 * @return {?proto.crosshair_util.PositionCoordinatesInt}
 */
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.prototype.getTopRight = function() {
  return /** @type{?proto.crosshair_util.PositionCoordinatesInt} */ (
    jspb.Message.getWrapperField(this, proto.crosshair_util.PositionCoordinatesInt, 5));
};


/**
 * @param {?proto.crosshair_util.PositionCoordinatesInt|undefined} value
 * @return {!proto.crosshair_util.MinimalCrosshairAndFrameCoordinates} returns this
*/
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.prototype.setTopRight = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.crosshair_util.MinimalCrosshairAndFrameCoordinates} returns this
 */
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.prototype.clearTopRight = function() {
  return this.setTopRight(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.prototype.hasTopRight = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional PositionCoordinatesInt bottom_left = 6;
 * @return {?proto.crosshair_util.PositionCoordinatesInt}
 */
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.prototype.getBottomLeft = function() {
  return /** @type{?proto.crosshair_util.PositionCoordinatesInt} */ (
    jspb.Message.getWrapperField(this, proto.crosshair_util.PositionCoordinatesInt, 6));
};


/**
 * @param {?proto.crosshair_util.PositionCoordinatesInt|undefined} value
 * @return {!proto.crosshair_util.MinimalCrosshairAndFrameCoordinates} returns this
*/
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.prototype.setBottomLeft = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.crosshair_util.MinimalCrosshairAndFrameCoordinates} returns this
 */
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.prototype.clearBottomLeft = function() {
  return this.setBottomLeft(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.prototype.hasBottomLeft = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional PositionCoordinatesInt bottom_right = 7;
 * @return {?proto.crosshair_util.PositionCoordinatesInt}
 */
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.prototype.getBottomRight = function() {
  return /** @type{?proto.crosshair_util.PositionCoordinatesInt} */ (
    jspb.Message.getWrapperField(this, proto.crosshair_util.PositionCoordinatesInt, 7));
};


/**
 * @param {?proto.crosshair_util.PositionCoordinatesInt|undefined} value
 * @return {!proto.crosshair_util.MinimalCrosshairAndFrameCoordinates} returns this
*/
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.prototype.setBottomRight = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.crosshair_util.MinimalCrosshairAndFrameCoordinates} returns this
 */
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.prototype.clearBottomRight = function() {
  return this.setBottomRight(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.crosshair_util.MinimalCrosshairAndFrameCoordinates.prototype.hasBottomRight = function() {
  return jspb.Message.getField(this, 7) != null;
};


goog.object.extend(exports, proto.crosshair_util);
